import React from 'react';
import Styles from './ScrollToBottomButton.module.scss';
import { observer } from 'mobx-react';
import { ArrowDown2 } from 'iconsax-react';
import CustomButton from '../button/CustomButton.js';
import Avatar from './avatar/Avatar.js';
import ContractionMessage from './message/ContractionMessage.js';
import classNames from 'classnames';
import { TICKET_CLOSE_STATUS } from '../../const/ChatConst.js';

@observer
class ScrollToBottomButton extends React.Component {
  //   componentDidMount() {
  //     let { store } = this.props;
  //   }

  render() {
    let { store, isUser } = this.props;
    let { isBottom, isNewMessage, lastUserMessage } = store;
    const isClosed = TICKET_CLOSE_STATUS.includes(store.channel.status);
    const isNew = isNewMessage && lastUserMessage && !isClosed;

    return (
      <div
        className={classNames(
          Styles.ScrollToBottom,
          (isUser || isClosed) && Styles.isUser,
        )}
      >
        <CustomButton
          className={classNames(
            Styles.Button,
            !isBottom && Styles.isNotBottom,
            isNew && Styles.isNew,
          )}
          onClick={() => store.debounceScrollToBottom()}
        >
          {isNew && (
            <div className={Styles.LastMessage}>
              {lastUserMessage?.sender && (
                <div className={Styles.Sender}>
                  <div className={Styles.Avatar}>
                    <Avatar
                      type={lastUserMessage?.sender?.type}
                      src={lastUserMessage?.sender?.avatar?.fullUrl}
                      seed={lastUserMessage?.sender?.id}
                    />
                  </div>
                  {lastUserMessage?.sender?.name}
                </div>
              )}
              <div className={Styles.Content}>
                <ContractionMessage message={lastUserMessage} />
              </div>
            </div>
          )}
          <div className={Styles.Icon}>
            <ArrowDown2 size={18} />
          </div>
        </CustomButton>
      </div>
    );
  }
}

export { ScrollToBottomButton };
